function toggleMobileExpandMenu(handle) {
  setTimeout(() => {
    const shopNav = document.getElementById("mobile-menu-shop-navigation");
    const brandNav = document.getElementById("mobile-menu-brand-navigation");
    const featuredNav = document.getElementById(
      "mobile-menu-featured-navigation",
    );
    const profileNav = document.getElementById(
      "mobile-menu-profile-navigation",
    );
    const searchNav = document.getElementById("mobile-search-menu");
    const desktopMenuOverlay = document.getElementById("desktop-menu-overlay");

    const allButtons = document.querySelectorAll(
      ".main-mobile-menu-link.expand",
    );
    allButtons.forEach((button) => button.classList.remove("active"));

    if (shopNav) shopNav.classList.remove("active");
    if (brandNav) brandNav.classList.remove("active");
    if (featuredNav) featuredNav.classList.remove("active");
    if (profileNav) profileNav.classList.remove("active");
    if (searchNav) searchNav.classList.remove("active");

    if (desktopMenuOverlay) {
      desktopMenuOverlay.classList.remove("active");
    }

    let targetNav = null;
    let targetButton = null;

    switch (handle) {
      case "shop":
        targetNav = shopNav;
        targetButton = document.querySelector(
          '.main-mobile-menu-link[onclick*="shop"]',
        );
        break;
      case "brand":
        targetNav = brandNav;
        targetButton = document.querySelector(
          '.main-mobile-menu-link[onclick*="brand"]',
        );
        if (desktopMenuOverlay) {
          desktopMenuOverlay.classList.add("active");
        }
        break;
      case "featured":
        targetNav = featuredNav;
        targetButton = document.querySelector(
          '.main-mobile-menu-link[onclick*="featured"]',
        );
        break;
      case "profile":
      case "profil":
        targetNav = profileNav;
        targetButton = document.querySelector(
          '.main-mobile-menu-link[onclick*="profile"]',
        );
        break;
    }

    if (targetNav) {
      targetNav.classList.add("active");
    }

    if (targetButton) {
      targetButton.classList.add("active");
    }
  }, 10);
}

window.toggleMobileExpandMenu = toggleMobileExpandMenu;

function toggleMobileSearchMenu() {
  const mobileSearchMenu = document.getElementById("mobile-search-menu");
  const header = document.getElementById("header-component");

  if (!mobileSearchMenu) return;

  if (mobileSearchMenu.classList.contains("active")) {
    mobileSearchMenu.classList.remove("active");
    header.classList.remove("mobile-menu-open");
    if (document.body) {
      document.body.style.overflow = "";
    }
  } else {
    mobileSearchMenu.classList.add("active");
    header.classList.add("mobile-menu-open");
    if (document.body) {
      document.body.style.overflow = "hidden";
    }

    setTimeout(() => {
      const searchInput = mobileSearchMenu.querySelector(
        "#header-search-input",
      );
      if (searchInput && typeof searchInput.focus === "function") {
        searchInput.focus();
      }
    }, 300);
  }
}

window.toggleMobileSearchMenu = toggleMobileSearchMenu;

function closeMobileSearchMenu() {
  const mobileSearchMenu = document.getElementById("mobile-search-menu");
  const header = document.getElementById("header-component");

  if (mobileSearchMenu && mobileSearchMenu.classList.contains("active")) {
    mobileSearchMenu.classList.remove("active");
    header.classList.remove("mobile-menu-open");
    if (document.body) {
      document.body.style.overflow = "";
    }
  }
}

window.closeMobileSearchMenu = closeMobileSearchMenu;

document.addEventListener("DOMContentLoaded", function () {
  const mobileMenuOverlay = document.getElementById("mobile-menu-overlay");
  if (!mobileMenuOverlay) return;

  const menuLinks = document.querySelectorAll(
    "#mobile-menu-overlay .mobile-menu-item .mobile-menu-link",
  );
  const submenus = document.querySelectorAll(
    "#mobile-menu-overlay .mobile-menu-submenu",
  );

  menuLinks.forEach((link) => {
    const menuItem = link.closest(".mobile-menu-item");
    const menuItemHandle = menuItem.getAttribute("data-menu-item");

    if (!menuItemHandle) return;

    link.addEventListener("click", function (e) {
      e.preventDefault();

      menuLinks.forEach((menuLink) => {
        menuLink.classList.remove("active");
      });

      submenus.forEach((submenu) => {
        submenu.classList.remove("active");
      });

      link.classList.add("active");

      const targetSubmenu = document.querySelector(
        `#mobile-menu-overlay .mobile-menu-submenu[data-parent="${menuItemHandle}"]`,
      );
      if (targetSubmenu) {
        targetSubmenu.classList.add("active");

        const mobileMenuOverlay = document.getElementById(
          "mobile-menu-overlay",
        );
        if (mobileMenuOverlay) {
          mobileMenuOverlay.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }
      }
    });
  });

  const otherLinkContainers = document.querySelectorAll(
    ".mobile-menu-other-link-container",
  );
  const otherSubmenus = document.querySelectorAll(".mobile-menu-other-submenu");

  otherLinkContainers.forEach((container) => {
    container.addEventListener("click", function () {
      const parentHandle = container.getAttribute("data-parent");
      const targetSubmenu = document.querySelector(
        `.mobile-menu-other-submenu[data-parent="${parentHandle}"]`,
      );
      const isCurrentlyActive = container.classList.contains("active");

      if (isCurrentlyActive) {
        container.classList.remove("active");
        if (targetSubmenu) {
          targetSubmenu.classList.remove("active");
        }
        const plusIcon = container.querySelector(".plus-icon");
        const minusIcon = container.querySelector(".minus-icon");
        if (plusIcon) plusIcon.style.display = "block";
        if (minusIcon) minusIcon.style.display = "none";
        return;
      }

      otherLinkContainers.forEach((btn) => {
        btn.classList.remove("active");
        const plusIcon = btn.querySelector(".plus-icon");
        const minusIcon = btn.querySelector(".minus-icon");
        if (plusIcon) plusIcon.style.display = "block";
        if (minusIcon) minusIcon.style.display = "none";
      });

      otherSubmenus.forEach((submenu) => {
        submenu.classList.remove("active");
      });

      container.classList.add("active");

      if (targetSubmenu) {
        targetSubmenu.classList.add("active");

        setTimeout(() => {
          const rect = targetSubmenu.getBoundingClientRect();
          const mobileMenuOverlay = document.getElementById(
            "mobile-menu-overlay",
          );
          const overlayRect = mobileMenuOverlay.getBoundingClientRect();
          const isFullyVisible =
            rect.bottom <= overlayRect.bottom && rect.top >= overlayRect.top;

          if (!isFullyVisible) {
            const submenuOffset = targetSubmenu.offsetTop;
            const overlayHeight = overlayRect.height;
            const submenuHeight = rect.height;

            const targetScrollTop =
              submenuOffset - overlayHeight / 2 + submenuHeight / 2;

            mobileMenuOverlay.scrollTo({
              top: Math.max(0, targetScrollTop),
              behavior: "smooth",
            });
          }
        }, 100);
      }

      const plusIcon = container.querySelector(".plus-icon");
      const minusIcon = container.querySelector(".minus-icon");
      if (plusIcon) plusIcon.style.display = "none";
      if (minusIcon) minusIcon.style.display = "block";
    });
  });

  function setFirstLinkActive() {
    const firstLink = document.querySelector(
      ".mobile-menu-item:first-child .mobile-menu-link",
    );
    if (firstLink && !firstLink.classList.contains("active")) {
      firstLink.classList.add("active");

      const firstMenuItem = firstLink.closest(".mobile-menu-item");
      const firstMenuItemHandle = firstMenuItem.getAttribute("data-menu-item");
      const firstSubmenu = document.querySelector(
        `.mobile-menu-submenu[data-parent="${firstMenuItemHandle}"]`,
      );
      if (firstSubmenu) {
        firstSubmenu.classList.add("active");
      }
      return true;
    }
    return false;
  }

  setFirstLinkActive();
  setTimeout(() => setFirstLinkActive(), 50);
  setTimeout(() => setFirstLinkActive(), 100);
  setTimeout(() => setFirstLinkActive(), 200);

  window.setFirstLinkActive = setFirstLinkActive;
});

function clearSearchInput() {
  const searchInput = document.querySelector(
    '#predictive-search-form input[type="search"]',
  );
  if (searchInput) {
    searchInput.value = "";
    searchInput.dispatchEvent(new Event("input", { bubbles: true }));
  }
}
